<template>
  <div class="rt-xpc-button-more">
    <rt-button
      :suffix-icon="suffixIcon"
      :color-type="buttonColor"
      text
      type="plain"
      @click="_changeExpand"
    >
      {{
        buttonText
      }}
    </rt-button>
  </div>
</template>

<script>
import RtButton from './rtButton';

export default {
  name: 'RtButtonMore',

  components: { RtButton },

  props: {
    // v-model绑定的值
    value: {
      type: Boolean,
      default: false
    },

    buttonColor: {
      type: String,
      default: 'neutral-secondary'
    },

    // 展开状态下的文本
    expandedText: {
      type: String,
      default () {
        return this.$tx('收起', 'xpc.common.collapse');
      }
    },
    // 展开状态下的文本
    expandedSuffixIcon: {
      type: String,
      default: 'rt-base-arrow-up-lined'
    },

    // 收起状态下的文本
    collapsedText: {
      type: String,
      default () {
        return this.$tx('查看更多', 'xpc.common.seemore');
      }
    },
    // 收起状态下的文本
    collapsedSuffixIcon: {
      type: String,
      default: 'rt-base-arrow-down-lined'
    }
  },

  data () {
    return {
      /**
       * @private
       */
      isExpand: this.value
    };
  },

  computed: {
    buttonText () {
      return this.isExpand ? this.expandedText : this.collapsedText;
    },

    suffixIcon () {
      return this.isExpand ? this.expandedSuffixIcon : this.collapsedSuffixIcon;
    }
  },

  watch: {
    value (v) {
      this.isExpand = v;
    }
  },

  methods: {
    /**
     * @private
     */
    _changeExpand () {
      this.isExpand = !this.isExpand;

      this.$emit('input', this.isExpand);
      this.$emit('change', this.isExpand);
      this.$emit('click');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtButtonMore.vue?7474a862